<template>
  <section id="ModalAddNewStore">
    <div v-if="!isLoadData">
      <legend class="font-weight-semibold font-size-lg px-3 py-2">
        <i class="fas fa-store mr-2" /> {{ $t("Store Information") }}
      </legend>
      <form
        action="#"
        class="px-3"
      >
        <fieldset>
          <!-- <div
            v-if="$parent.activePlatform == 'gosell' && $parent.userDataRefer"
            class="alpha-blue p-2 text-blue-800 mb-3"
          >
            <strong><i class="fa-solid fa-circle-info mr-1" />{{ $t('Additional information') }} :</strong> {{ $t('Congratulations! You have receive a special promotion. Ref code: REF12399, this promotion will expire within 3 days.') }}
          </div> -->
          <div class="row">
            <div class="col-md-12">
              <template>
                <label>{{ $t("Select Platform") }} <span class="text-danger">*</span></label>
                <div class="mb-3 row">              
                  <div 
                    class="block-shipping-card col-4 border-0" 
                    v-for="platform in listPlatform" 
                    :key="platform.index"
                  >
                    <div 
                      :class="['border-1 d-inline-block border card d-flex flex-row m-0 overflow-hidden rounded-xln h-100',platform.code == activePlatform ? 'border-primary' :'',,platform.code == 'incoming' ? 'point-none' :'']"
                      style="cursor: pointer;align-items: center;"
                      @click="selectPlatform(platform.code)"
                    >
                      <div class="card-body h-100">
                        <p class="d-block font-size-lg mb-0 pb-0">
                          {{ $t(platform.name) }}
                        </p>
                        <p 
                          v-if="platform.text"
                          class="font-size-sm mb-0 pt-0 text-muted"
                        >
                          {{ $t(platform.text) }}
                        </p> 
                      </div>
                      <div class="pr-3"> 
                        <img
                          v-if="platform.src"
                          width="80px"
                          :src="platform.src"
                        >
                      </div>
                      <span
                        v-if="platform.code == activePlatform"
                        :class="['label-active', platform.code == activePlatform ? 'active-select' : '']"
                      >
                        <i class="fa-solid fa-check" />
                      </span>
                    </div>
                    <span
                      v-if="platform.plan_series != ''"
                      :class="['platform-plan-series badge position-absolute text-capitalize',platform.plan_bg == platform.plan_bg ? 'bg-free' : '']"
                    >
                      {{ platform.plan_series }}
                    </span>
                  </div> 
                </div>
              </template>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label>{{ $t('Create Store By') }} </label>
              <div
                class="d-flex align-item-center"
                id="create-store-by-content"
              >
                <div class="filter-option"> 
                  <div class="d-flex form-group mb-0">
                    <div 
                      v-for="itemCreateStoreBy in listCreateStoreBy"
                      :key="itemCreateStoreBy.index"
                      class="mr-3"
                    >   
                      <div class="custom-control custom-radio">
                        <input 
                          type="radio" 
                          class="custom-control-input" 
                          name="createStoreBy" 
                          :id="itemCreateStoreBy.code" 
                          :value="itemCreateStoreBy.code"  
                          v-model="type"
                          @click="handleTypeChange(itemCreateStoreBy.code)" 
                        >
                        <label 
                          class="custom-control-label text-capitalize" 
                          :for="itemCreateStoreBy.code"
                        >{{ $t(itemCreateStoreBy.name) }}</label>
                      </div>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Store Name') }} <span class="text-danger">*</span></label>
                <input
                  type="text"
                  :placeholder="$t('Store Name')"
                  class="form-control"
                  maxlength="60"
                  @change="inputStoreNameChange"
                  v-model.trim.lazy="$v.form.name.$model"
                >
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.name.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('store name') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Store Industry') }} <span class="text-danger">*</span></label>
                <Select2
                  :options="industryOptions"
                  :settings="industryOptionsSettings"
                  v-model.trim.lazy="$v.form.industry.$model"
                />
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.industry.required && submitStatus"
                >
                  {{ $t('Please select') }} <span class="lower-case">{{ $t('store industry') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-if="type == 'corporate'"
          >
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Company Name') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Company Name')"
                  class="form-control"
                  v-model.trim.lazy="$v.form.company_name.$model"
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Tax ID') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Tax ID')"
                  class="form-control"
                  v-model.trim.lazy="$v.form.tax_identification.$model"
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Phone') }} <span class="text-danger">*</span></label>
                <input
                  type="text"
                  :placeholder="$t('Enter phone')"
                  class="form-control"
                  v-model.trim.lazy="$v.form.telephone1.$model"
                >
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.telephone1.required && submitStatus"
                >
                  {{ $t('Please enter') }}<span class="lower-case"> {{ $t('phone') }}</span>
                </div>
                <div
                  v-if="!$v.form.telephone1.numeric && submitStatus"
                  class="validation-invalid-label"
                >
                  <span class="lower-case">{{ $t('only numeric') }}</span>
                </div>
                <div
                  v-if="!$v.form.telephone1.checkIsValidPhoneNumber && submitStatus && $v.form.telephone1.$model"
                  class="validation-invalid-label"
                >
                  {{ $t('Invalid telephone format') }}
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Store Contact Email') }} <span class="text-danger">*</span></label>
                <input
                  type="text"
                  :placeholder="$t('Store Contact Email')"
                  class="form-control"
                  v-model.trim.lazy="$v.form.email_contact.$model"
                >
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.email_contact.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('store contact email') }}</span>
                </div>
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.email_contact.email && submitStatus"
                >
                  {{ $t('email format invalid') }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                <input
                  type="text"
                  :placeholder="$t('Address')"
                  class="form-control"
                  v-model.trim.lazy="$v.form.address.address1.$model"
                >
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.address.address1.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('address') }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Sub District') }} <span class="text-danger">*</span></label>
                <addressinput-subdistrict
                  v-model.trim.lazy="$v.form.address.county.$model"
                  input-class="form-control"
                  label=""
                  :placeholder="$t('Enter sub district')"
                />
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.address.county.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('sub district') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('District') }} <span class="text-danger">*</span></label>
                <addressinput-district
                  v-model.trim.lazy="$v.form.address.city.$model"
                  input-class="form-control"
                  label=""
                  :placeholder="$t('Enter district')"
                />
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.address.city.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('district') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                <addressinput-province
                  v-model.trim.lazy="$v.form.address.state.$model"
                  input-class="form-control"
                  label=""
                  :placeholder="$t('Enter province')"
                />
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.address.state.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('province') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Zipcode') }} <span class="text-danger">*</span></label>
                <addressinput-zipcode
                  v-model.trim.lazy="$v.form.address.postcode.$model"
                  input-class="form-control"
                  label=""
                  :placeholder="$t('Enter zipcode')"
                />
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.address.postcode.required && submitStatus"
                >
                  {{ $t('Please enter') }} <span class="lower-case">{{ $t('zipcode') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t('Country') }} <span class="text-danger">*</span></label>
                <Select2
                  :options="countryOptions"
                  :settings="countryOptionsSettings"
                  v-model.trim.lazy="$v.form.address.country.$model"
                />
                <div
                  class="validation-invalid-label d-inline"
                  v-if="!$v.form.address.country.required && submitStatus"
                >
                  {{ $t('Please select') }} <span class="lower-case">{{ $t('country') }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>{{ $t('Link to access the store') }} 
                  <span class="text-danger">* 
                    <a 
                      style="color:#706F72;"
                      data-trigger="hover"
                      data-popup="popover-custom"
                      data-placement="top"
                      :data-content="'<img '+classImg+' src='+imgSMS+' '+sizeImgSMS+'>'"
                      data-html="true"
                    >
                      <i class="fas fa-info-circle" />
                    </a>
                  </span> 
                </label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('Enter the URL you want.')"
                    v-model.trim="$v.form.subdomain.$model"
                    @change="changedomain"
                    @keyup="changedomain"
                    style="text-transform: lowercase;"
                  >
                  <div
                    v-if="$v.form.subdomain.minLength && $v.form.subdomain.required && $v.form.subdomain.isUnique && $v.form.subdomain.langDomain"
                    style="position: absolute;right: 95px;border: 0;background: transparent;width: 36px;height: 36px;text-align: center;line-height: 36px;z-index: 10;"
                  >
                    <span class="text-success"><i class="far fa-check" /></span>
                  </div>
                  <span class="input-group-append">
                    <span class="input-group-text">.gosaas.app</span>
                  </span>
                </div>

                <div
                  class="validation-invalid-label d-block"
                  v-if="!$v.form.subdomain.required && (($v.form.subdomain.$model).length || submitStatus) "
                >
                  {{ $t('Please enter Store URL Name') }}
                </div>
                <div
                  class="validation-invalid-label d-block"
                  v-if="!$v.form.subdomain.isUnique && isUnique1 && (($v.form.subdomain.$model).length || submitStatus) "
                >
                  <span>{{ $t('This Store URL is already! please replace') }}</span>
                </div>
                <div
                  class="validation-invalid-label d-block"
                  v-if="!$v.form.subdomain.langDomain && (($v.form.subdomain.$model).length || submitStatus) "
                >
                  <span>{{ $t('Please use Store URL in english and numbers only.') }}</span>
                </div>
                <div
                  class="validation-invalid-label d-block"
                  v-if="!$v.form.subdomain.minLength && (($v.form.subdomain.$model).length || submitStatus) "
                >
                  <span class="lower-case">{{ $t('Please enter at least 3 characters.') }}</span>
                </div>
                <div
                  class="validation-invalid-label d-block"
                  v-if="!$v.form.subdomain.maxLength && (($v.form.subdomain.$model).length || submitStatus) "
                >
                  <span class="lower-case">{{ $t('Domain name max length 16 character.') }}</span>
                </div>
                <div
                  class="mt-2"
                  v-if="form.subdomain"
                >
                  {{ $t('The link to access your store is') }} <span class="text-primary text-lowercase">https://{{ form.subdomain }}.gosaas.app</span>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
    <div
      class="modal-body"
      v-else
    >
      <placeholder-content is-load="true" />
    </div>
  </section>
</template>

<script>
import {
  setStoreInfo,
} from "../stores/Params.js";
import { required, email, numeric,helpers, minLength ,maxLength } from "vuelidate/lib/validators";
import { isValidPhoneNumber } from 'libphonenumber-js'
import Select2 from "v-select2-component";
import "switchery";
import CentralApi from '@/services/endpoint/central.service'
const checkIsValidPhoneNumber = (phoneNumber) => isValidPhoneNumber(phoneNumber, 'TH')
const langDomain = helpers.regex('langdomain',/^[0-9a-zA-Z]+$/)
import Cookies from "js-cookie";

import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
export default {
  components: {
    Select2,
    PlaceholderContent,
    
  },
  data() {
    return {
      show_address: false, 
      form : {
          subdomain : '',
          name : '',
          industry : '',
          company_name : '',
          tax_identification : '',
          telephone1 : '',
          email_contact : '',
          address : {
            address1 : '',
            address2: '',
            county : '',
            city: '',
            state: '',
            postcode: '',
            country : '1',
          }
      },
      storeData : setStoreInfo(),
      isUnique1 : false,
      industryOptions: [],
      industryOptionsSettings: {
        minimumResultsForSearch: Infinity,
        templateResult : this.templateCustom,
        templateSelection: this.templateCustomSelect,
        placeholder: {
            id: '',
            name: this.$t("Select")+'...'
        },
        allowClear: false,
        escapeMarkup: function (m) {
            return m;
        },
      },
      countryOptions: [],
      countryOptionsSettings: {
        minimumResultsForSearch: Infinity,
        templateResult : this.templateCustom,
        templateSelection: this.templateCustomSelect,
        placeholder: {
            id: '',
            name: this.$t("Select")+'...'
        },
        allowClear: false,
        escapeMarkup: function (m) {
            return m;
        },
      },
      submitStatus: false,
      idCard: [],
      houseRegistration: [],
      imgSMS: require("@/assets/images/url-example.png"),
      sizeImgSMS: 'width="100%"',
      classImg:'style="margin-top:6px !important"',
      isLoadData: true,
      activePlatform:'gosell',
      listPlatform:[
        {
          code:'gosell',
          name:'Gosell',
          plan_series:'',
          plan_bg:'',
          text:'Omnichannel eCommerce Platform',
          src:require(`@/assets/global_assets/images/stores/tab-logo-gosell.png`)
        },
        {
          code:'goship',
          name:'Goship',
          plan_series:'free',
          plan_bg:'success-400',
          text:'Cheap & Fast Courier Service',
          src:require(`@/assets/global_assets/images/stores/tab-logo-goship.png`)
        },
        // {
        //   code:'incoming',
        //   name:'Incoming',
        //   text:'Incoming soon...',
        //   src:''
        // },
      ],
      type:'personal',
      // activeCreateStoreBy:'personal',
      listCreateStoreBy:[
        {
          code:'personal',
          name:'Personal', 
          icon:'fa-solid fa-user-vneck-hair'
        },
        {
          code:'corporate',
          name:'Corporate', 
          icon:'far fa-building'
        }
      ]
    };
  },
  created() {
      this.storeData.protocal = window.location.protocol
  },
  validations: {
    form: {
        subdomain: {
              required,
              langDomain,
              minLength: minLength(3),
              maxLength: maxLength(16),
              async isUnique(value) {

                  if(!value) return true;
                  this.isUnique1 = false;
                  if(value.length >= 3){
                      if(value == 'account' || value == 'nevergiveup51'){

                          this.isUnique1 = true;
                          return false;

                      }else{

                          let result = await CentralApi.Domain.checkDomain(value);

                              if(result.data.status == true){
                                  this.isUnique1 = false;
                                  return true;
                              }else{

                                  this.isUnique1 = true;
                                  return false;
                              }
                      }

                  }

              }
          },
        name : { required },
        industry : { required },
        company_name : {},
        tax_identification : {},
        telephone1 : {
            required ,
            numeric,
            checkIsValidPhoneNumber,
        },
        email_contact : {
            required,
            email,
        },
        address : {
          address1 : { required },
          county: { required },
          city: { required },
          state: { required },
          postcode: { required },
          country : { required },
      }
    },
  },
  mounted() {
        var self = this;
        setTimeout(function(){
            self.show_address = true;
        }, 3000);

        this.getCountry();
        this.getIndustry();
        this.getUser();
        this.popoverHover();
        this.isLoadData = false;
        
    },
  methods: {
    selectPlatform(platform=null){
      this.activePlatform = platform;
      // this.$parent.createType = platform;
    },
    checkForm: function(e) {
       this.submitStatus = true;
       if(this.activePlatform =='gosell'){
          this.storeData.plan_slug = 'gosellcoth-free';
          this.storeData.plan_type = 'gosell';
          this.$parent.loadingGoSell = true;
          
       }else{
          this.storeData.plan_slug = 'goshipcoth-free';
          this.storeData.plan_type = 'goship';
          this.$parent.loadingGoShip = true;
       }
       
       this.storeData.name = this.form.name;
       this.storeData.domain = this.form.subdomain.toLowerCase();
       this.storeData.mobile = this.form.telephone1;

       this.storeData.setting.name = this.form.name;
       this.storeData.setting.store_industry = this.form.industry;
       this.storeData.setting.company_name = this.type == 'corporate' ?  this.form.company_name : '';
       this.storeData.setting.tax_identification = this.type == 'corporate' ? this.form.tax_identification : '';
       this.storeData.setting.phone = this.form.telephone1;
       this.storeData.setting.email_contact = this.form.email_contact;
       this.storeData.setting.address1 = this.form.address.address1;
       this.storeData.setting.county = this.form.address.county;
       this.storeData.setting.district = this.form.address.city;
       this.storeData.setting.state = this.form.address.state;
       this.storeData.setting.zipcode = this.form.address.postcode;

       this.storeData.location.name = this.form.name;
       this.storeData.location.address1 = this.form.address.address1;
       this.storeData.location.city = this.form.address.city;
       this.storeData.location.state = this.form.address.state;
       this.storeData.location.postcode = this.form.address.postcode;
       this.storeData.location.county = this.form.address.county;

  
      if (!this.$v.form.$invalid) {
            this.$emit('onLoadingChange',true);
            this.createStore(this.activePlatform);
            
      } else {
            // this.loading = false;
            this.$emit('onLoadingChange',false);
      }
      // this.$parent.logloading = true; 
      console.log('this.storeData',this.storeData);
      return;
     
    },
    validateInfo:function() {
     this.submitStatus = true;
     return new Promise((resolve, reject) => {
      if(this.$v.form.$invalid){
        this.submitStatus = true;
        reject('error');
      }else{
        resolve(true);
      }
     })
    },
    changedomain: function(){
        // this.submitStatus = true;
        this.form.subdomain.toLowerCase();
    },
    onComplete: function(){

    },
    async getUser() {

        if(this.$store.state.central.centralUser && ("data" in this.$store.state.central.centralUser)) {
          this.form.telephone1 = this.$store.state.central.centralUser.data.data.mobile
          this.form.email_contact = this.$store.state.central.centralUser.data.data.email
          return
        }

        let data = await CentralApi.Auth.getUser();
        this.form.telephone1 = data.data.data.mobile;
        this.form.email_contact = data.data.data.email;
    },
    async getCountry() {
        let data =  await CentralApi.Country.getCountry('?status=1')
        this.countryOptions = data.data.data;
    },
    async getIndustry() {
        let query = "?status=1";
        let data =  await CentralApi.Industry.getIndustry(query);
        this.industryOptions = data.data.data;
    },
    createStore(createStoreType = null) {
        var self = this;
        this.$parent.showClose = false;
        CentralApi.Tenant.createStore(this.storeData).then(function(res) {
            if(res.data.status == false) {
                //  self.loading = false;
                self.$emit('onLoadingChange',false);
                 self.$parent.showClose = true;
                 self.$toastr.e(self.$t("Reached Store Limit"),"<span class='icon-blocked'></span>"+self.$t('Error'));
            }else{
                // self.loading = false;
               
                const tempTenant = {
                  domain : res.data.data.domain,
                  name : res.data.data.tenant_name,
                  plan_group : res.data.data.plan_group,
                  progress : 0 ,
                  id : res.data.data.domain + res.data.tenant_id
                }

                Cookies.set('tempTenant', JSON.stringify(tempTenant));

                self.$emit('onLoadingChange',false);
                self.$toastr.i(self.$t("Waiting in queue..."),"<span class='icon-info22'></span>"+self.$t("Processing"));
                self.$parent.$refs.close.click();
                self.$parent.isCreate = true;
                self.$parent.reloadStrore(createStoreType, false , tempTenant);
                self.$parent.showModal = false;
            }

         }).catch((error) => {
            // self.loading = false;
            self.$emit('onLoadingChange',false);
            self.$parent.showClose = true;
            self.$toastr.e(self.$t("Please fill all the information"),"<span class='icon-blocked'></span>"+self.$t('Error'));
            console.log(error, 'catch');
         })
    },
    
    templateCustom(e) {
        let option = "";
        if (e.text == "Searching…") {
            option = this.$t("Searching")+"...";
        } else {
            option = this.$t(e.name);
        }
        return option;
    },
    templateCustomSelect(e) {
        var text = this.$t(e.name);
        return text;
    },
    validateTextDomain: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode >= 65 && charCode <= 90)) {
            evt.preventDefault();;
      } else {
        return true;
      }
    },
    handleTypeChange: function(type){
      this.type = type
    },
    inputStoreNameChange:function(){
      let {name} = this.form
      if(!name) return 
       
      this.form.name = name.replace(/[]/g, '')
      name = name.toLowerCase()
      const validate = /^[a-z0-9]*$/;
      let string = [...name].map(item=> validate.test(item) ? item : '').join('')
      string = string.length > 16 ? string.substring(0, 16) + '' : string

      let value = "";
      if(string.length == 0) value = this.generateText(8)

      if(string.length > 0 && string.length <= 3) value = `${string}${this.generateText(+(3 - string.length))}`

      if(string.length > 3) value = string

      this.checkDomainLoop(value)
    },
    generateText:function(length){
      if(length < 8 ) return Math.random().toString(16).substr(2, length);
     
      let string = ""; 
      let stringCheck = ""; 
      let numCheck = "";
      
      do{
        string = Math.random().toString(16).substr(2, length)

        stringCheck = string.replace(/[^a-z]/g,"").length > 4 ? true : false ;
        numCheck = string.replace(/[^0-9]/g,"").length > 1 ? true : false ;

        if(stringCheck && numCheck) return string;
        
      }while(!stringCheck || !numCheck)
      
    },
    cancleForm(){
      this.form.subdomain = ''
      this.form.name = ''
      this.form.industry = ''
      this.form.company_name = ''
      this.form.tax_identification = ''
      this.form.address.address1 = ''
      this.form.address.address2 = ''
      this.form.address.city = ''
      this.form.address.state = ''
      this.form.address.postcode = ''
      this.form.address.county = ''
    },
    async checkDomainLoop(string){
      let response

      do {
          response = await CentralApi.Domain.checkDomain(string);
          if(response.data.status){
            this.form.subdomain = string
          }else{
            string = this.generateText(8)
          }
      }
      while (!response.data.status);

    },
    popoverHover(){
      $('[data-popup=popover-custom]').popover({
          template: `<div class="popover border-0 shadow-none bg-transparent p-0 mt-4" style="margin-top:10px;">
                        <div class="popover-body p-0 w-100 m-0" ></div>
                    </div>`
      });
      
    }
  },
}
</script>

<style scoped>
  #create-store-by-content button {
    width:113px;
  }
  section#ModalAddNewStore{
    margin-bottom: 80px;
  }
  span.label-active {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 35px 35px 0 0;
    border-color: transparent #2196f3 transparent;
    display: none;
  }
  span.label-active.active-select { 
    display: block;
  }
  span.active-select i {
    position: absolute;
    right: -28px;
    top: -16px;
    font-size: 10px;
    color: #fff;
  }
  #ModalAddNewStore input[type="radio"]:checked~.custom-control-label::before {
      color: #455964;
      background: none;
      border-color: #455964;
  }
  #ModalAddNewStore .custom-radio .custom-control-input:checked~.custom-control-label::after {
    background: #455964;
    border-color: #455964; 
  }
  .bg-free {
    background-color: #8bc34a;
  }
  span.platform-plan-series {
    top: -10px;
    right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/central/account/stores/ModalAddNewStore.vue